var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 relative"},[_c('MBScan',{attrs:{"doc-type":_vm.docType,"should-start-scan":""},on:{"results":_vm.onScanResult,"close":_vm.sendCloseMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }